import React, { useState } from "react";
import UseGetData from "../../../hooks/useFetchData";
import { GetAccess } from "../../../utils/RolesandAccess";
import EditIcon from "../../../assets/icons/EditIcon";
import { AddIcon } from "../../../assets/icons";
import { ViewLabelwithDataLoader } from "../../../components/Loader";
import { ViewLabelwithData } from "../../../components/View/ViewLabelwithData";
import CreateorUpdate from "./form";

function EmailSetupIndex() {
  const { data, getData, isLoading } = UseGetData({ url: "/server_email/" });
  const [showMyModal, setShowMyModal] = useState(false);
  const handleOnClose = () => setShowMyModal(false);
  const [show,setShow] = useState(false);
  
  return (
    <>
      <div className=" w-full h-[calc(100vh-140px)] overflow-y-auto">
        <div className="pb-2 px-2 flex justify-between items-center w-full">
          <h4 className="text-sm 2xl:text-base font-medium text-heading">
            Email Setup (SMTP Server/Mail Sever Details)
          </h4>
          <div className=" w-8 flex justify-center items-center cursor-pointer">
            {GetAccess("admin_create") && (
              <div onClick={() => setShowMyModal(true)}>
                {data.length > 0 ? (
                  <div className=" w-7 h-7 bg-primary rounded flex justify-center items-center">
                    <EditIcon />
                  </div>
                ) : (
                  <AddIcon />
                )}
              </div>
            )}
          </div>
        </div>
        <div className=" w-full px-6 h-[calc(100vh-180px)] pt-4  space-y-6">
          {isLoading == true ? (
            <>
              {[...Array(4)].map((_, index) => {
                return <ViewLabelwithDataLoader key={index} />;
              })}
            </>
          ) : (
            <>
              <ViewLabelwithData
                title="Server Name"
                value={data[0]?.server_name || "-"}
              />
              <ViewLabelwithData title="Port" value={data[0]?.port || "-"} />
              <ViewLabelwithData
                title="Email / User Name"
                value={data[0]?.useremail || "-"}
              />
              <ViewLabelwithData
                title="Password / Auth Key"
                value={show == true? data[0]?.passwordOrAuthkey:"**************"||"-"}
              />
              <input type="checkbox" onChange={(e)=>setShow(e.target.checked)} /><span className=" text-xs ml-2">Show Password / Auth Key</span>
            </>
          )}
        </div>
      </div>
      {data?.length > 0 ? (
        <CreateorUpdate
          data={data[0]}
          onClose={handleOnClose}
          visible={showMyModal}
          refreshData={getData}
          id={data[0]?.id}
        />
      ) : (
        <CreateorUpdate
          onClose={handleOnClose}
          visible={showMyModal}
          refreshData={getData}
          id={data[0]?.id}
        />
      )}
    </>
  );
}

export default EmailSetupIndex;
